// Horizontal bar chart for the Skip report pages — pure HTML/CSS bars,
// identical technique to the Collections MetricsPage BarChart (no external
// charting library, per the Reports module convention).

import styles from '../skipReports.module.css';

function formatNumber(n: number): string {
  return new Intl.NumberFormat('en-GB').format(n);
}

export interface BarDatum {
  label: string;
  value: number;
}

interface BarChartProps {
  data: BarDatum[];
  colour: string;
}

export function BarChart({ data, colour }: BarChartProps): JSX.Element {
  if (data.length === 0) {
    return <p className={styles.empty}>No data for this period.</p>;
  }
  const max = data.reduce((acc, d) => (d.value > acc ? d.value : acc), 0);
  return (
    <ul className={styles.barList}>
      {data.map((d, idx) => {
        const pct = max === 0 ? 0 : Math.max(2, Math.round((d.value / max) * 100));
        return (
          <li key={`${d.label}-${idx}`} className={styles.barRow}>
            <span className={styles.barLabel} title={d.label}>
              {d.label}
            </span>
            <div className={styles.barTrack}>
              <span
                className={styles.barFill}
                style={{ width: `${pct}%`, background: colour }}
              />
            </div>
            <span className={styles.barValue}>{formatNumber(d.value)}</span>
          </li>
        );
      })}
    </ul>
  );
}
